const routeComponent = (view: string) => {
  return (): unknown => import(`../view/${view}.vue`);
};

const routes = [
  {
    path: "/",
    name: "home",
    meta: { title: "总览概况", closable: false, icon: "overview" },
    component: routeComponent("index/home"),
  },
  {
    path: "/variety/:key?",
    name: "variety",
    meta: { title: "栏目内容", dynamic: true },
    component: routeComponent("variety/variety"),
  },
  {
    path: "/report",
    name: "report",
    meta: { title: "企业上报", icon: "report" },
    component: routeComponent("report/report"),
  },
  {
    path: "/setting",
    name: "setting",
    meta: { title: "系统设置", icon: "system" },
    component: routeComponent("system/setting"),
  },
  // User
  {
    path: "/user",
    name: "user",
    meta: { title: "用户中心" },
    component: routeComponent("user/user"),
  },
  {
    path: "/login",
    name: "login",
    meta: { title: "登录", loggedAuth: false, keepAlive: false, frame: false },
    component: routeComponent("user/login"),
  },
];

export default routes;
